import type { z } from "zod";
import { type CatalogsResponse } from "@/services/catalogService";
import { createContext, useContext } from "react";
import type { createSkuSchema } from "@/schemas/sku/create";

interface SkuContextType {
    onClearFile: () => void,
    onUpload: (file: File) => void,
    onComplete: (data: z.infer<typeof createSkuSchema>) => void,
    isFetching: boolean,
    catalogs: CatalogsResponse | null
}

export const SkuContext = createContext<SkuContextType | null>(null);

export const useSkuContext = () => {
    const context = useContext(SkuContext);
    if (!context) {
        throw new Error("useSkuContext must be used within a SkuContextProvider");
    }
    return context;
}